import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
// import ChildPic from "../../../../../assets/images/child-round.png";
import { Link } from "react-router-dom/cjs/react-router-dom";

import { useDispatch, useSelector } from "react-redux";
// import YoutubePic from "../../../../../assets/images/youtube.png";
import useKidListFunctionality from "../../../../customHooks/kidListHook";
import SetRulesDisableSupervison from "../SetRulesDisableSupervison";
import useSetRules from "../useSetRules";
import RestrictedWebsiteRow from "./RestrictedWebsiteRow";
import useFirebase from "../../../../../useFirebase";
import CommonStatus from "../../Common/CommonStatus";
import useDeviceStatus from "../../../../customHooks/deviceStatusProvider";
import DeleteChildInfo from "../../modals/DeleteChildInfo";
import { deleteKidAccount } from "../../../AxiosRtk/AddNewChild";
import { setSelectedKidId } from "../../../AxiosRtk/DashBoard";
import { getMyIPAddress } from "../../../AxiosRtk/Miscellaneous";
import useLangTranslation from "../../../../customHooks/languageProvider";
import Select from "react-select";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import KidImage from "../../../../shared/KidImage/KidImage";

const AllowedWebsite = (props) => {
  // console.log(props)
  // const [] = useState(null);
  const dispatch = useDispatch();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [device, setDevice] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reason, setReason] = useState({ value: "", error: "" });

  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [kid, setKid] = useState(null);
  const [webUrl, setWebUrl] = useState("");
  const [error, setError] = useState("");
  const [webMonitoringData, setWebMonitoringData] = useState(null);
  const [isFormChanged, setIsFormChanged] = useState(false); // State to track if changes were made
  const { postCollectionData, getCollectionData, createCollectionData } =
    useFirebase();
  const { getLangTranslation } = useLangTranslation();
  // const
  const history = useHistory();
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const { handleTimeSupervision } = useSetRules();
  const { getImage } = useKidListFunctionality();

  const { kidList, selectedKidId, kidDevicesList } = useSelector(
    ({ dashboard }) => dashboard
  );

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  const handleGoBack = useCallback(() => {
    history.goBack();
  });

  function callFireStore(payload) {
    if (setRulesData) {
      postCollectionData(device, { webmonitoring: payload });
    } else {
      createCollectionData(device, { webmonitoring: payload });
    }

    getCollectionData(device);
    dispatch(
      setShowMessage({
        showMessage: true,
        message: "DATA_FETCH",
        defaultMessage: "Data updated successfully",
      })
    );
    setWebUrl("");
    setIsFormChanged(false); // Reset change tracking after saving
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (props) {
      // console.log(props);
      const state = props?.location?.state?.device;
      setDevice(state);
    }
  }, [props]);

  useEffect(() => {
    if (device) {
      getDeviceStatusData(device);
    }
  }, [device]);

  useEffect(() => {
    if (kidList && selectedKidId) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKid(kid);
    }
  }, [kidList, selectedKidId]);

  useEffect(() => {
    if (setRulesData) {
      setWebMonitoringData({ ...setRulesData?.webmonitoring });
    }
  }, [setRulesData]);

  function closeModal() {
    setShowModal(false);
  }

  const getPublicIp0 = useCallback(async () => {
    try {
      const { data: ipAddData } = await getMyIPAddress();
      return ipAddData?.ip;
    } catch (error) {
      console.log("Ip0", error);
    }
  }, []);

  async function handleContinue() {
    if (!reason?.value) {
      setReason({
        ...reason,
        error: "Please enter reason",
      });
      return;
    }

    setLoader(true);

    const ip = await getPublicIp0();

    const deleteProfilePayload = {
      kidId: selectedKidId,
      kidName: kid?.childName,
      ipAddress: ip,
      reason: reason?.value,
    };

    deleteKidAccount(deleteProfilePayload)
      .then((res) => {
        closeModal();
        setShowDeletedModal(true);
      })
      .catch((err) => {
        setReason({
          ...reason,
          error: err?.response?.data?.message + ". Redirecting to dashboard.",
        });
        setTimeout(() => {
          window.location.href = "/dashboard";
        }, 2500);
        console.log(
          "child delete catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoader(false);
        dispatch(setSelectedKidId(kidList[0]?.ID));
      });
    // console.log(deleteProfilePayload)
  }

  function handleWebUrlSelect(e) {
    const { name, checked } = e.target;
    const allowedWebsite = [...webMonitoringData?.allowedWebsite];
    const targetWebsite = allowedWebsite?.find(
      (item) => parseInt(item?.addUpdateTime) === parseInt(name)
    );
    const targetIndex = allowedWebsite?.findIndex(
      (item) => parseInt(item?.addUpdateTime) === parseInt(name)
    );
    const tempObj = { ...targetWebsite };
    tempObj["isChecked"] = checked ? 1 : 0;

    allowedWebsite?.splice(targetIndex, 1, tempObj);
    // console.log(restrictedWebsite)
    const payload = {
      ...webMonitoringData,
      allowedWebsite,
    };
    // console.log(payload)
    setWebMonitoringData(payload);
    setIsFormChanged(true); // Track change
  }

  function isValidURL(url) {
    // Regular expression pattern for a valid URL
    var urlPattern =
      /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;

    // Test the URL against the pattern
    return urlPattern.test(url);
  }

  function handleSave() {
    setError(""); // Clear previous errors
  
    if (!webUrl) {
      setError("URL is required");
      return;
    }
  
    let formattedWebUrl = webUrl.trim();
  
    // Regular expression to check for valid domain format (without protocol)
    const domainPattern = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/; // Check for valid domain (e.g., hello.com)
  
    // Regular expression to validate full URL (with protocol)
    const validUrlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
  
    // If it's a valid domain (without protocol), prepend 'https://'
    if (domainPattern.test(formattedWebUrl)) {
      // Prepend 'https://' if no protocol is found
      if (!/^https?:\/\//i.test(formattedWebUrl)) {
        formattedWebUrl = `https://${formattedWebUrl}`;
      }
    } else if (!validUrlPattern.test(formattedWebUrl)) {
      // If URL is incomplete or doesn't match domain pattern or doesn't have protocol
      setError("Invalid URL");
      return;
    }
  
    try {
      // Extract the hostname (in case the URL is complete, we get the hostname)
      const newHostName = new URL(formattedWebUrl).hostname;
  
      // Check if the website already exists in the allowed list
      const isDuplicate = webMonitoringData?.allowedWebsite?.some(
        (item) => item?.webSiteName === newHostName
      );
  
      if (isDuplicate) {
        setError("This website is already in the allowed list.");
        return;
      }
  
      // Create the object for the allowed website
      const newTempObj = {
        addUpdateTime: Date.now(),
        blockedStatus: true,
        status: 1,
        webSiteName: newHostName,
        websiteThumbnail: null,
        websiteUrl: formattedWebUrl, // Store the URL with https://
      };
  
      const allowedWebsite = [...webMonitoringData?.allowedWebsite];
      allowedWebsite.push(newTempObj);
  
      const collectionPayload = {
        ...webMonitoringData,
        allowedWebsite: allowedWebsite.map((item) => {
          delete item?.isChecked;
          return item;
        }),
      };
  
      // Call Firestore to save the data
      callFireStore(collectionPayload);
      setWebUrl(""); // Clear the input field after saving
      setIsFormChanged(false); // Reset change tracking after saving
    } catch (error) {
      setError("Invalid URL format");
      console.error(error);
    }
  }
  


  function handleAllSelect(e) {
    const { checked } = e.target;
    let allowedWebsite = [...webMonitoringData?.allowedWebsite];
    allowedWebsite = allowedWebsite?.map((item, index) => {
      const temp = { ...item };
      temp["isChecked"] = checked ? 1 : 0;
      return temp;
    });

    const payload = {
      ...webMonitoringData,
      allowedWebsite,
    };

    setWebMonitoringData(payload);
    setIsFormChanged(true); // Track change
  }

  function handleDelete() {
    const itemsToBeDeleted = [...webMonitoringData?.allowedWebsite]?.filter(
      (item) => item?.isChecked
    );

    if (itemsToBeDeleted?.length === 0) {
      return;
    }

    const itemsNotToBeDeleted = [...webMonitoringData?.allowedWebsite]
      ?.filter((item) => !item?.isChecked)
      ?.map((item) => {
        delete item?.isChecked;
        return item;
      });

    // console.log(itemsNotToBeDeleted);
    const collectionPayload = {
      ...setRulesData?.webmonitoring,
      allowedWebsite: itemsNotToBeDeleted,
    };
    console.log(collectionPayload);

    callFireStore(collectionPayload);
  }

  // console.log(webMonitoringData)
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap align-items-center separator space-20">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                        }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation(
                      "WEB_MONITORING_ALLOWED_WEBSITES",
                      "Allowed websites"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              {/* <span className="icon-wrap icon-rounded me-2 p-0 overflow-hidden ratio ratio-1x1 border-0">
                <img src={getImage(kid?.name, kid?.gender)} alt="" />
              </span> */}
              <KidImage imageUrl={kid?.childName} gender={kid?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kid?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                {/*  <select
                  className="form-select text-dark single-select-text"
                  value={device || ""}
                  onChange={(e) => setDevice(e.target.value)}
                >
                  <option value="">Select</option>
                  {kidDevicesList?.map((item, index) => {
                    return (
                      <option value={item?.ID} key={index}>
                        {item?.Name}
                      </option>
                    );
                  })}
                </select>*/}
                <Select
                  className="custom-select "
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value == device) || ""
                  }
                  onChange={(val) => {
                    setDevice(val.value);
                  }}
                  isSearchable={false}
                />
              </div>
            </div>
            {device && (
              <>
                <SetRulesDisableSupervison
                  enableSupervision={setRulesData?.enableSupervision}
                  handleTimeSupervision={handleTimeSupervision}
                  deviceSelected={device}
                />
                <span className="icon-wrap pt-cursor">
                  {/* <i className="icon-setting"></i> */}
                  <div className="dropdown">
                    <i
                      className="icon-setting  pt-cursor"
                      type="button"
                      id="dropdownMenuButton1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    />
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li
                        className="px-6 pt-cursor fw-semibold d-flex justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/manage-notifications")
                        }
                      >
                        {getLangTranslation(
                          "MANAGE_NOTIFICATIONS",
                          "Manage notifications"
                        )}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() => history.push("/set-rules/copy-settings")}
                      >
                        {getLangTranslation("COPY_SETTINGS", "Copy settings")}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1"
                        onClick={() =>
                          history.push("/set-rules/default-settings")
                        }
                      >
                        {getLangTranslation(
                          "SETRULE_LOAD_DEFAULT_SETTINGS",
                          "Load default settings"
                        )}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                      <li
                        className="px-6 pt-cursor d-flex fw-semibold justify-content-between align-items-center gap-1 text-danger"
                        onClick={() => setShowModal(true)}
                      >
                        {getLangTranslation(
                          "SET_RULES_DELETE_CHILD_PROFILE",
                          "Delete child's profile"
                        )?.replace('child', kid?.childName)}{" "}
                        <i className="icon-arrow-right" />
                      </li>
                    </ul>
                  </div>
                </span>
              </>
            )}
            <DeleteChildInfo
              showModal={showModal}
              closeModal={closeModal}
              handleContinue={handleContinue}
              loader={loader}
              reason={reason}
              setReason={setReason}
              getLangTranslation={getLangTranslation}
            />
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h3 className="text-blue-900 mb-1">
            {getLangTranslation(
              "WEB_MONITORING_ADD_AN_EXCEPTION_TO_BLOCK_DIALOG_DESCRIPTION",
              "Add website to block"
            )}
          </h3>
          <label htmlFor="email" className="form-label text-gray">
            {getLangTranslation(
              "WEB_MONITORING_ADD_AN_EXCEPTION_TO_BLOCK_DIALOG_ENTER_WEBSITE_URL_HINT",
              "Enter website URL"
            )}
          </label>
          <div className="d-flex gap-4">
            <div className="input-group">
              <span
                className={`input-group-text  fs-5 text-dark ${lang?.isRTL === 1
                    ? "border-start-0 ps-0 rounded-0 rounded-end"
                    : "border-end-0 pe-0"
                  }`}
                id="basic-addon3"
              >
                <i className="icon-globe text-gray"></i>
              </span>
              <input
                type="text"
                className={`form-control text-dark ${lang?.isRTL === 1
                    ? "border-end-0 rounded-0 rounded-start"
                    : "border-start-0"
                  }`}
                placeholder="https://www.example.com or http://www.xyz.com"
                id="WEB_URL"
                name="WEB_URL"
                value={webUrl}
                onChange={(e) => {
                  setWebUrl(e.target.value);
                  setIsFormChanged(true); // Mark as changed when user types
                }}
              />
            </div>
            <button
              className="btn btn-primary"
              type="button"
              onClick={() => handleSave()}
              disabled={!isFormChanged} // Disable Save button when no change is made
            >
              <span className="btn-upper-case">
                {getLangTranslation("SAVE", "Save")}
              </span>
            </button>
          </div>
          {error && (
            <div className="text-start text-danger text-capitalize my-1">
              {error}
            </div>
          )}
          <hr className="my-6" />
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-6">
            <div>
              <h5 className="text-success text-uppercase mb-1">
                {getLangTranslation(
                  "WEB_MONITORING_ALLOWED_WEBSITES",
                  "Allowed website"
                )}
              </h5>
              <h6 className="text-gray fw-normal mb-0">
                {getLangTranslation(
                  "WEB_MONITORING_ALLOWED_WEBSITED_DESCRIPTION",
                  "The following websites are allowed"
                )}
              </h6>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-6">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="SELECT_ALL"
                  id="SELECT_ALL"
                  checked={
                    webMonitoringData?.allowedWebsite?.length > 0 &&
                    webMonitoringData?.allowedWebsite?.filter(
                      (item) => item?.isChecked !== 1
                    )?.length < 1
                  }
                  onChange={handleAllSelect}
                />
                <label
                  className="form-check-label text-dark"
                  htmlFor="SELECT_ALL"
                >
                  {getLangTranslation(
                    "MANAGE_NOTIFICATION_SELECT_ALL",
                    "Select all"
                  )}
                </label>
              </div>
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={handleDelete}
              >
                {getLangTranslation(
                  "SCREENSHOT_HISTORY_BUTTON_DELETE_SELECTED",
                  "Delete Selected"
                )}
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle" scope="col">
                    <div className="form-check">
                      {/* <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="taskName"
                                            /> */}
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation("WEB_ADDRESS", "Web address")}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle"></th>
                </tr>
              </thead>
              <tbody>
                {webMonitoringData?.allowedWebsite?.map((item, index) => {
                  return (
                    <RestrictedWebsiteRow
                      item={item}
                      key={index}
                      handleWebUrlSelect={handleWebUrlSelect}
                      callFireStore={callFireStore}
                    />
                  );
                })}
              </tbody>
            </table>
            {webMonitoringData?.allowedWebsite?.length === 0 && (
              <div className="text-center my-2 text-capitalize">
                -- {getLangTranslation("NO_DATA_LOG", "No data found")} --
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AllowedWebsite;
